import React from "react";
import { Box, IconButton } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import IMG from "../assets/Overdue.png";

const OverdueCard = () => {
  const handleView = () => {};
  return (
    <Box
      className="rounded-md  py-2 px-4"
      style={{
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.1)",
        height: "60vh",
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="text-main font-bold text-left text-xs">
          Overdue/Upcoming Covenants
        </div>
        <IconButton
          aria-label="<>"
          onClick={handleView}
          sx={{ height: 24, width: 24 }}
        >
          <ArrowForwardOutlinedIcon />
        </IconButton>
      </div>
      {/* Content Rows */}
      <Box>
        <Box className="text-center p-2">
          <div className="text-main font-bold text-[10px]">5</div>
        </Box>
      </Box>
      <Box className="flex items-center gap-2 justify-between">
        <Box className="text-left">
          <div className="text-gray-600 text-[10px] text-center">Financial</div>
          <div className="text-gray-600 text-[10px] text-center">0</div>
        </Box>
        <Box className="text-left">
          <div className="text-gray-600 text-[10px] text-center">
            Regulatory
          </div>
          <div className="text-gray-600 text-[10px] text-center">1</div>
        </Box>
        <Box className="text-left">
          <div className="text-gray-600 text-[10px] text-center">
            Collateral
          </div>
          <div className="text-gray-600 text-[10px] text-center">0</div>
        </Box>
        <Box className="text-left">
          <div className="text-gray-600 text-[10px] text-center">Monetary</div>
          <div className="text-gray-600 text-[10px] text-center">2</div>
        </Box>
      </Box>
    </Box>
  );
};

export default OverdueCard;
